// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../GroupForm/GroupFormPage.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Game form page overrides - use dice icon for header */
.game-form-page .ttbFormHeaderTitle::before {
  content: '🎲';
}

.game-form__textarea {
  resize: vertical;
  min-height: 80px;
}

.game-form__players-row {
  display: flex;
  align-items: flex-end;
  gap: var(--space-3);
}

.game-form__player-field {
  flex: 0 0 auto;
  min-width: 0;
}

/* Hint is an inline span: next to a narrow number input it would sit beside it */
.game-form-page .ttbFieldHint {
  display: block;
}

.game-form__player-field .ttbFieldLabel {
  margin-bottom: var(--space-1);
}

.game-form__players-separator {
  font-size: var(--font-size-body-lg);
  font-weight: 700;
  color: var(--color-text-secondary);
  padding-bottom: var(--space-3);
}

.game-form__number-input {
  width: 100px;
  text-align: center;
}

.game-form__import-btn {
  margin-left: auto;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Games/GameFormPage.css"],"names":[],"mappings":"AAGA,wDAAwD;AACxD;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,iFAAiF;AACjF;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["@import '../_base.css';\n@import '../GroupForm/GroupFormPage.css';\n\n/* Game form page overrides - use dice icon for header */\n.game-form-page .ttbFormHeaderTitle::before {\n  content: '🎲';\n}\n\n.game-form__textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.game-form__players-row {\n  display: flex;\n  align-items: flex-end;\n  gap: var(--space-3);\n}\n\n.game-form__player-field {\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n/* Hint is an inline span: next to a narrow number input it would sit beside it */\n.game-form-page .ttbFieldHint {\n  display: block;\n}\n\n.game-form__player-field .ttbFieldLabel {\n  margin-bottom: var(--space-1);\n}\n\n.game-form__players-separator {\n  font-size: var(--font-size-body-lg);\n  font-weight: 700;\n  color: var(--color-text-secondary);\n  padding-bottom: var(--space-3);\n}\n\n.game-form__number-input {\n  width: 100px;\n  text-align: center;\n}\n\n.game-form__import-btn {\n  margin-left: auto;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
